// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import SolutionOutlinedSvg from "@ant-design/icons-svg/es/asn/SolutionOutlined";
import AntdIcon from '../components/AntdIcon';

var SolutionOutlined = function SolutionOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: SolutionOutlinedSvg
  }));
};

SolutionOutlined.displayName = 'SolutionOutlined';
export default React.forwardRef(SolutionOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/SolutionOutlined.js
// module id = 1849
// module chunks = 0